import React from "react";
import { CreditCard, ShieldCheck } from "lucide-react";

export default function Payment() {
  const stripeLink = "https://buy.stripe.com/14A7sM0EO84e0KFfjr0sU03";

  const handlePayment = () => {
    window.location.href = stripeLink;
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        color: "#111",
        padding: "100px 20px",
        fontFamily: "'Elza', sans-serif",
        minHeight: "100vh",
      }}
    >
      {/* Badge */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
        <div
          style={{
            backgroundColor: "#f3f0ff",
            color: "#6d28d9",
            padding: "8px 22px",
            borderRadius: "50px",
            fontWeight: "600",
            fontSize: "0.9rem",
          }}
        >
          🔒 Secure Payment
        </div>
      </div>

      {/* Heading */}
      <h1
        style={{
          textAlign: "center",
          fontSize: "2.8rem",
          fontWeight: "800",
          marginBottom: "15px",
        }}
      >
        Complete Your Payment
      </h1>

      <p
        style={{
          textAlign: "center",
          fontSize: "1.1rem",
          color: "#555",
          maxWidth: "600px",
          margin: "0 auto 50px",
        }}
      >
        Fast, secure checkout powered by Stripe. Your payment information is fully encrypted.
      </p>

      {/* Card */}
      <div
        style={{
          maxWidth: "480px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "18px",
          padding: "45px 30px",
          textAlign: "center",
          border: "1px solid #eee",
          boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
        }}
      >
        <CreditCard size={40} color="#6d28d9" style={{ marginBottom: "15px" }} />

        <h2 style={{ fontSize: "1.6rem", fontWeight: "700", marginBottom: "10px" }}>
          Secure Checkout
        </h2>

        <p style={{ fontSize: "0.95rem", color: "#666", marginBottom: "25px" }}>
          Payments are processed securely via Stripe.
        </p>

        {/* Payment Button */}
        <button
          onClick={handlePayment}
          style={{
            backgroundColor: "#6d28d9",
            color: "#fff",
            padding: "14px 35px",
            borderRadius: "50px",
            fontWeight: "600",
            fontSize: "1rem",
            border: "none",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#5b21b6")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#6d28d9")}
        >
          Pay Securely
        </button>

        {/* Accepted Cards */}
        <div style={{ marginTop: "30px" }}>
          <p style={{ fontSize: "0.8rem", color: "#888", marginBottom: "10px" }}>
            We accept
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <img src="https://img.icons8.com/color/48/visa.png" alt="Visa" height="28" />
            <img src="https://img.icons8.com/color/48/mastercard.png" alt="Mastercard" height="28" />
            <img src="https://img.icons8.com/color/48/amex.png" alt="Amex" height="28" />
            <img src="https://img.icons8.com/color/48/discover.png" alt="Discover" height="28" />
            <img src="https://img.icons8.com/color/48/apple-pay.png" alt="Apple Pay" height="28" />
            <img src="https://img.icons8.com/color/48/google-pay-india.png" alt="Google Pay" height="28" />
          </div>
        </div>

        {/* Security Note */}
        <div
          style={{
            marginTop: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            color: "#777",
            fontSize: "0.85rem",
          }}
        >
          <ShieldCheck size={16} color="#6d28d9" />
          100% secure & encrypted payment
        </div>
      </div>
    </div>
  );
}